export * from './src/password-reset-view.component';
